import axios from 'axios';
import store from '../store';
import moment from 'moment';
const baseURL = location.host.includes('norahme.com') ? '/' : 'http://localhost:3210';
//const baseURL = location.host == 'app.norahme.com' ? '/' : 'https://app.norahme.com';
const http = axios.create({
    baseURL,
    headers: {
      'x-auth-token': localStorage.getItem('x-norahme-token') ? localStorage.getItem('x-norahme-token') : undefined 
    }
});
http.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // check response headers if x-unread is set
  document.body.style.pointerEvents = 'auto';
  if(document.querySelector('#request')) document.querySelector('#request').style.display = 'none';
  if(response.headers['x-unread']){
    // set unread
    const unread = JSON.parse(response.headers['x-unread']);
    store.state.unread = unread;
    /* for (const key in unread) {
      store.state.unread[key] = true;
    } */
  }
  // check if url contains one of the keys in unread
  const url = response.config.url;
  const keys = Object.keys(store.state.unread);
  for(let i=0; i<keys.length; i++){
    if(url.indexOf(keys[i]) != -1){
      store.state.unread[keys[i]] = false;
    }
    if(url.indexOf('BALANCE') > -1) store.state.unread.payments = false;
  }
  store.state.lastRequest = moment();
  setTimeout(()=>{
    if(moment().diff(store.state.lastRequest, 'seconds') > 25){
      http.get('/api/users/get?me=1').then((response)=>{
        if(response.data){
          store.state.auth = response.data;
        }
      });
    }
  }, 30000);
  // Do something with response data
  return response;
}, function (error) {
  console.log(error);
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  document.body.style.pointerEvents = 'auto';
  if(document.querySelector('#request')) document.querySelector('#request').style.display = 'none';
  if(error.response && error.response.status == 401){
    
    localStorage.removeItem('x-norahme-token');
    location.href = '/login';
  }
  return Promise.reject(error);
});


// disbale window click event on sending request
http.interceptors.request.use(function (config) {
  document.body.style.pointerEvents = 'none';
  if(document.querySelector('#request')) document.querySelector('#request').style.display = 'block';
  return config;
}, function (error) {
  return Promise.reject(error);
});

export default http;
